(() => {
  const match = window.location.pathname.match(/^\/collections\/([^/]+)/);
  const handle = match ? match[1] : '';
  const saleHandles = new Set(['sale', 'sale-damen', 'sale-herren', 'sale-kinder', 'winter-sale', 'outlet']);
  if (!saleHandles.has(handle)) return;

  document.body.classList.add('elk-sale-collection');

  const colorKeys = new Set(['farbe', 'color', 'colour', 'couleur']);
  const slugify = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const selectedColorFrom = (block) => {
    const link = block.querySelector('a.product-link[href*="variant="], a.sezerium-url[href]');
    if (!link) return '';
    try {
      const url = new URL(link.href, window.location.origin);
      for (const [key, value] of url.searchParams.entries()) {
        if (colorKeys.has(key.toLowerCase())) return slugify(value);
      }
    } catch (_) {}
    return '';
  };

  const filterBlock = (block) => {
    if (!block.matches('.sezerium-product, [data-sezerium-variant]')) return;

    const saleColors = new Set(
      (block.dataset.elkSaleColors || '')
        .split('|')
        .map(slugify)
        .filter(Boolean)
    );
    const selectedColor = selectedColorFrom(block);
    const hasVisibleSalePrice = Boolean(block.querySelector('.price__was, .sezerium-compare-at-price'));
    const keep = saleColors.size > 0 && selectedColor
      ? saleColors.has(selectedColor)
      : hasVisibleSalePrice;

    block.classList.toggle('elk-sale-hidden', !keep);
    block.hidden = !keep;
    block.classList.add('elk-sale-checked');
  };

  let scheduled = false;
  const filterSaleCards = () => {
    scheduled = false;
    document.querySelectorAll('product-block').forEach(filterBlock);
  };
  const scheduleFilter = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(filterSaleCards);
  };

  scheduleFilter();
  new MutationObserver(scheduleFilter).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleFilter);
})();

